module.exports = __webpack_public_path__ + "8300803b.svg";